import * as React from "react";

const InformationNotification: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
                d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm1-3V7H7v6h2zM8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                fillRule="evenodd"
            ></path>
        </svg>
    );
};



export default React.memo(InformationNotification);
